"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preview = preview;
exports.addTrailingSlash = addTrailingSlash;
exports.removePaddingChars = removePaddingChars;
exports.trim = trim;
exports.getBool = getBool;
exports.padLeft = padLeft;
exports.padRight = padRight;
exports.namedRegexMatch = namedRegexMatch;
exports.stripUrl = stripUrl;
var arrays_1 = require("./arrays");
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function preview(value, desiredLength) {
    desiredLength = desiredLength || 200;
    var quarterLength = Math.floor(desiredLength / 4);
    if (value && value.length > desiredLength) {
        var firstPart = value.substr(0, quarterLength);
        var secondPart = value.substr(value.length - quarterLength);
        return "".concat(firstPart, "..").concat(secondPart, " (").concat(value.length, ")");
    }
    return value;
}
function addTrailingSlash(text) {
    var s = text + "";
    if (s.length !== 0 && s[s.length - 1] !== "/" && s[s.length - 1] !== "\\")
        s += "/";
    return s;
}
function removePaddingChars(data) {
    var lkey = _keyStr.indexOf(data.charAt(data.length - 1));
    if (lkey === 64) {
        return data.substring(0, data.length - 1);
    }
    return data;
}
function trim(text, charsToRemove) {
    var i = 0;
    while (i < text.length && (0, arrays_1.contains)(charsToRemove, text.charAt(i)))
        i++;
    text = text.substring(i);
    i = text.length;
    while (i > 0 && (0, arrays_1.contains)(charsToRemove, text.charAt(i - 1)))
        i--;
    text = text.substring(0, i);
    return text;
}
// be careful, look at the test first
function getBool(val) {
    if (val == null)
        return false;
    if (typeof val === "boolean")
        return val === true;
    if (typeof val === "string") {
        if (val == "")
            return false;
        val = val.replace(/^\s+|\s+$/g, "");
        if (val.toLowerCase() == "true" || val.toLowerCase() == "yes")
            return true;
        val = val.replace(/,/g, ".");
        val = val.replace(/^\s*\-\s*/g, "-");
    }
    if (!isNaN(val))
        return parseFloat(val) != 0;
    return false;
}
function padLeft(width, s, padding) {
    return width <= s.length ? s : padLeft(width, padding + s, padding);
}
function padRight(width, s, padding) {
    return width <= s.length ? s : padRight(width, s + padding, padding);
}
// @text Contains the text to match
// @regex A regular expression object (f.e. /.+/)
// @matchNames An array of literal strings where each item
//             is the name of each group
function namedRegexMatch(text, regex, matchNames) {
    if (!text)
        return {};
    var matches = regex.exec(text);
    return matches.reduce(function (result, match, index) {
        if (index > 0)
            // This substraction is required because we count
            // match indexes from 1, because 0 is the entire matched string
            result[matchNames[index - 1]] = match;
        return result;
    }, {});
}
var guidRegex = /[0-9a-f]{8}-?[0-9a-f]{4}-?[1-5][0-9a-f]{3}-?[89ab][0-9a-f]{3}-?[0-9a-f]{12}/gi;
var thumbprintRegex = /[0-9a-f]{40}/gi;
var numberSegmentRegex = /\/[0-9]+(\/|$)/gi;
var md5Regex = /[a-f0-9]{32}/gi;
function stripUrl(url) {
    if (!url)
        return url;
    var querySeparatorIndex = url.indexOf("?");
    if (querySeparatorIndex >= 0)
        url = url.substring(0, querySeparatorIndex);
    url = url.replace(thumbprintRegex, "{thumbprint}");
    url = url.replace(guidRegex, "{guid}");
    url = url.replace(numberSegmentRegex, "/{number}/");
    url = url.replace(md5Regex, "{md5}");
    return url;
}
